import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { CaesarLayoutComponent } from './caesar-layout/caesar-layout.component';
import { UgyekComponent } from './ugyek/ugyek.component';
import { UgyComponent } from './ugy/ugy.component';
import { SzemelyekComponent } from './szemelyek/szemelyek.component';
import { UgytipusokComponent } from './ugytipusok/ugytipusok.component';
import { SablonokComponent } from './sablonok/sablonok.component';
import { IktatoComponent } from './iktato/iktato.component';
import { TeendokComponent } from './teendok/teendok.component';
import { RiportokComponent } from './riportok/riportok.component';
import { BeallitasokComponent } from './beallitasok/beallitasok.component';

// CAESAR jogi ügykezelő feature-modul. Saját IonicModule importtal, hogy az ion-*
// elemek a modul állapotától függetlenül ismertek legyenek (a routing az
// app-routing.module-ban direkt komponens-referenciákkal eager módon tölti be).
@NgModule({
  declarations: [CaesarLayoutComponent, UgyekComponent, UgyComponent, SzemelyekComponent, UgytipusokComponent, SablonokComponent, IktatoComponent, TeendokComponent, RiportokComponent, BeallitasokComponent],
  imports: [CommonModule, FormsModule, RouterModule, IonicModule],
  exports: [CaesarLayoutComponent, UgyekComponent, UgyComponent, SzemelyekComponent, UgytipusokComponent, SablonokComponent, IktatoComponent, TeendokComponent, RiportokComponent, BeallitasokComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CaesarModule {}
